import { OnDestroy, Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * Base component que implementa padrões para evitar memory leaks
 * Todos os componentes devem estender esta classe
 */
@Injectable()
export abstract class BaseComponent implements OnDestroy {
  /**
   * Subject para gerenciar subscriptions e evitar memory leaks
   * Use: this.someService.getData().pipe(takeUntil(this.destroy$)).subscribe(...)
   */
  protected destroy$ = new Subject<void>();

  /**
   * Método chamado automaticamente quando o componente é destruído
   * Limpa todas as subscriptions ativas
   */
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  /**
   * Método auxiliar para verificar se o componente ainda está ativo
   * Útil para evitar operações em componentes já destruídos
   */
  protected isDestroyed(): boolean {
    return this.destroy$.closed;
  }

  /**
   * Método auxiliar para executar código apenas se o componente ainda estiver ativo
   * @param callback Função a ser executada se o componente estiver ativo
   */
  protected safeExecute(callback: () => void): void {
    if (!this.isDestroyed()) {
      callback();
    }
  }
}
